import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useForm } from 'react-hook-form';
import { useAlert } from 'common/alertContext';
import api from 'api';
import { t } from 'i18next';

const useSendEmailToSpecificAddress = () => {
  const { handleSubmit, control, reset } = useForm({
    mode: 'all',
    defaultValues: { email: '', linkType: '' },
  });

  const [showDialog, setShowDialog] = useState(false);
  const [linkType, setLinkType] = useState(null);
  const { setStateAlert } = useAlert();

  const mutation = useMutation(api.Users.sendEmailWithApplicationForm, {
    onSuccess: (data) => {
      setStateAlert({ open: true, message: t('Email envoyé avec succès à ') + ` ${data.email}` });
      close();
    },
    onError: (error) => setStateAlert({ open: true, message: `${error.response.data.error}` }),
  });

  const submit = handleSubmit((data) => {
    const payload = {
      email: data.email || email,
      linkType: data.linkType || linkType,
    };
    mutation.mutate(payload);
  });

  const close = () => {
    setShowDialog(false);
    setLinkType(null);
    reset();
  };

  const clickSendEmail = (type) => {
    setShowDialog(true);
    setLinkType(type);
  };

  return {
    state: {
      form: { control },
      nav: { showDialog, linkType },
    },
    actions: {
      clickSendEmail,
      close,
      submit,
      isLoading: mutation.isLoading,
    },
  };
};

export { useSendEmailToSpecificAddress };
